export default __webpack_public_path__ + "img/blue.cde0c499.png";